<!--
 * @Description: 
 * @Date: 2024-03-15 10:37:33
-->
<template>
  <div
    class="box"
    :class="{ vertical: isOssRole }"
    :style="{ '--parent-dom-height': parentDomHeight }"
  >
    <div class="menus">
      <router-link
        :replace="isOssRole"
        class="item"
        :class="{ active: route.path === path }"
        :to="{ path: path, query: route.query }"
        v-for="{ label, name, path, icon } in PageConfig"
        :key="name"
      >
        <div class="icon" v-html="icon"></div>
        <p>{{ label }}</p>
      </router-link>
    </div>
    <div class="content">
      <router-view v-slot="{ Component }" class="router">
        <component :is="Component" />
      </router-view>
    </div>
  </div>
</template>

<script setup lang="tsx">
import { PageConfig } from '../router/index';
import { useZsStore } from '../store';
import { useRoute } from 'vue-router';
import { useParentHeight } from '../hooks/use-parent-height';
import { watch } from 'vue';
import { getConfig } from '../data-source/api';
import { PUBLISH_SOURCE_COMPANY, PUBLISH_SOURCE_SYSTEM } from '../config';
import { throttle } from 'lodash';

const route = useRoute();

type FirstParameter<T> = T extends (a: infer P, ...args: any) => any
  ? P
  : never;

const { setValue, isOssRole } = useZsStore();

watch(
  () => route.query,
  throttle(newQuery => {
    (
      ['enterpriseName', 'enterpriseId', 'configId'] as Array<
        FirstParameter<typeof setValue>
      >
    ).forEach((key: any) => {
      setValue(key, newQuery[key] as string);
      if (key === 'configId') {
        if (isOssRole.value) {
          setValue('dataOrigin', 'own');
        } else {
          getConfig({ configId: newQuery[key] as string }).then(({ data }) => {
            if (data && Object.keys(data).length > 0) {
              if (
                (isOssRole.value && data.source == PUBLISH_SOURCE_SYSTEM) ||
                (!isOssRole.value && data.source == PUBLISH_SOURCE_COMPANY)
              ) {
                setValue('dataOrigin', 'own');
              } else {
                setValue('dataOrigin', 'other');
              }
            } else {
              setValue('dataOrigin', 'own');
            }
          });
        }
      }
    });
  }, 1000),
  { immediate: true, deep: true }
);

const parentDomHeight = useParentHeight();
</script>

<style lang="scss" scoped>
$menusWidth: 200px;
$maxHeight: var(--parent-dom-height);
.box {
  display: flex;
}
.menus {
  width: $menusWidth;
  height: $maxHeight;
  background-color: #fff;
  flex-shrink: 0;
  border-right: 1px solid gainsboro;

  .item {
    padding: 14px 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 12px;
    .icon {
      width: 18px;
      line-height: 0;
    }
    p {
      color: #333333;
      font-size: 14px;
    }
    &:hover {
      background-color: var(--xrk-color-primary-light-9);
      opacity: 0.9;
    }
    &.active {
      --active-color: var(--xrk-color-primary);
      p {
        color: var(--xrk-color-primary);
      }
    }
  }
}
.content {
  flex-grow: 1;
  height: $maxHeight;
  background-color: #fff;
  border-radius: 18px;
  padding: 20px;
  overflow: auto;
}
.vertical {
  flex-direction: column;
  gap: 2px;
  height: $maxHeight;
  .menus {
    width: 100%;
    height: initial;
    display: flex;
    flex-wrap: wrap;
    .item {
      padding: 14px 20px;
      justify-content: center;
      &:hover {
        background-color: #fff;
      }
    }
  }
  .content {
    height: auto;
    border-radius: 0;
  }
}
</style>
